import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetDataTitularByCodeResponse = {
  value: {
    ciudad: string;
    codigo: number;
    codigoSpecified: boolean;
    direccion: string;
    esBajaLogica: boolean;
    esBajaLogicaSpecified: boolean;
    nombre: string;
    pais: string;
    razonSocial: string;
    ruc: string;
    tieneCredito: string;
    tipoDocumentoMagma: number;
    tipoDocumentoMagmaSpecified: boolean;
    baja_logica: string;
  };
};

type GetDataTitularByCodeParams = {
  codigo: number | string;
};

export const getDataTitularByCode = async (
  query: GetDataTitularByCodeParams
): Promise<GetDataTitularByCodeResponse['value']> => {
  try {
    const res = await apiClient.post<GetDataTitularByCodeResponse>(
      Endpoints.TitularCodigo,
      {
        codCliente: Number(query.codigo),
      }
    );

    return res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
